
import { supabase } from "@/integrations/supabase/client";
import { AuthResult } from "./types";

export const resetPassword = async (email: string): Promise<AuthResult> => {
  try {
    // Use the current origin as the redirect URL
    const redirectUrl = `${window.location.origin}/reset-password`;
    
    console.log('Sending password reset email to:', email);
    console.log('Redirect URL:', redirectUrl);
    
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectUrl,
    });
    
    if (error) {
      console.error('Password reset error:', error);
      throw error;
    }
    
    console.log('Password reset email sent successfully');
    return { data, error: null };
  } catch (error: any) {
    console.error("Error resetting password:", error);
    return { data: null, error };
  }
};

/**
 * Update user password during recovery session
 */
export const updatePasswordInRecovery = async (newPassword: string): Promise<AuthResult> => {
  try {
    console.log('Updating password in recovery session...');
    
    // Verify we have a valid session first
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      throw new Error('No active recovery session found. Please click the reset link from your email again.');
    }
    
    // Check if this is actually a recovery session
    if (!session.user?.aud || session.user.aud !== 'authenticated') {
      throw new Error('Invalid session type. Please use the reset link from your email.');
    }
    
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    
    if (error) {
      console.error('Password update error:', error);
      throw error;
    }
    
    console.log('Password updated successfully in recovery session');
    return { data, error: null };
  } catch (error: any) {
    console.error("Error updating password:", error);
    return { data: null, error };
  }
};

/**
 * Verify if the current session is a valid password recovery session
 */
export const verifyRecoverySession = async (): Promise<{ isValid: boolean; error?: string }> => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      return { isValid: false, error: 'No active session found' };
    }
    
    // Additional validation could be added here
    // For now, we'll consider any authenticated session as valid
    return { isValid: true };
  } catch (error: any) {
    console.error('Error verifying recovery session:', error);
    return { isValid: false, error: error.message };
  }
};
